import React, { Component } from 'react'
import { Button, Form, Table, Modal, Input, message, InputNumber, Spin, Row, Col } from 'antd'
import { delRecommend, addRecommend, getGoodList, getRecommendGoods,sortRecommend } from '_src/api/api'
import './style/freshGoods.less'

const { Search } = Input
class AddFlash extends Component{
    constructor(){
        super()
        this.state={
            isLoading:false,
            list:[],
            goodsList:[],
            pageData: {
                total: 0,
                current: 1,
            },
            selectData:{
                total: 0,
                current: 1,
            },
            params:{
                goodsName:'',
                pageNum:0,
                pageSize:10,
                recommendType:1,
                status:''
            },
            selectParam:{
                goodsName:'',
                pageNum:0,
                pageSize:10,
                status:1
            },
            createModelVisible:false,
            selectedRowKeys :[],
            sort:'',        //排序
            flashPrice: 0,  //秒杀价格
            flashSum: 0,    //秒杀数量
            remainSum: 0    //剩余数量
        }
    }
    componentDidMount(){
        this.loadData()
    }
    loadData(){
        const { params } = this.state
        this.setState({
            isLoading:true
        })
        getRecommendGoods(params).then(res =>{
            this.setState({
                isLoading:false,
                list:res.data.content,
                pageData:{
                    current:res.data.pageable.pageNumber+1,
                    total:res.data.totalElements,
                    pageSize:res.data.pageable.pageSize
                }
            })
        }).catch(err =>{
            console.log(err)
            this.setState({
                isLoading:false,
                list:[],
                pageData:{
                    current:0,
                    total:0,
                    pageSize:0
                }
            })
        })
    }
    getGoods = () =>{
        const {selectParam } = this.state
        this.setState({
            isLoading:true
        })
        getGoodList(selectParam).then(res =>{
            this.setState({
                isLoading:false,
                goodsList:res.data.content,
                selectData:{
                    current:res.data.pageable.pageNumber+1,
                    total:res.data.totalElements,
                    pageSize:res.data.pageable.pageSize
                }
            })
        }).catch(err =>{
            this.setState({
                isLoading:false,
                list:[],
                selectData:{
                    current:0,
                    total:0,
                    pageSize:0
                }
            })
        })
    }
    onSearchName = (value) => {
        const { params } = this.state
        params.pageNum = 0
        params.goodsName = value
        this.setState({
            params
        })
        this.loadData()
    }
    onSearchModel =(value) =>{
        const { selectParam } = this.state
        selectParam.pageNum = 0
        selectParam.goodsName = value
        this.setState({
            selectParam
        })
        this.getGoods()
    }
     // 分页
    onPageChange = (e) => {
        const { params } = this.state
        params.pageNum = e.current - 1
        this.setState({
            params
        })
        this.loadData()
    }
      // 分页
    selectPageChange = (e) => {
        const { selectParam } = this.state
        selectParam.pageNum = e.current - 1
        this.setState({
            selectParam
        })
        this.getGoods()
    }
    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };
    //加入推荐
    addSubmit = () =>{
        const {selectedRowKeys} = this.state
        if(selectedRowKeys.length<1){
            message.info('请选择商品')
        }else{
            const params = {
                ids:selectedRowKeys,
                type:1
            }
            const hide = message.loading('提交中')
            addRecommend(params).then(res =>{
                hide()
                if(res){
                    message.success('添加成功', 1.5, () => {                     
                        this.setState({
                            createModelVisible:false,
                            selectedRowKeys:[]
                        })
                        this.loadData()
                    })
                }
            }).catch(err =>{
                hide()
                console.log(err)
            })
        }
    }
    //删除
    delRecommend = (id) =>{
        const hide = message.loading('提交中')
        delRecommend(id).then(res =>{
            hide()
            if(res){
                message.success('删除成功', 1.5, () => {                     
                    this.loadData()
                })
            }
        }).catch(err =>{
            hide()
        })
    }
    //排序
    sorting = (id) =>{
        console.log(id)
        const { sort } = this.state
        if(sort<1){
            message.info('排序数字需大于0')
        }else{
            const params ={
                id,
                sort
            }
            const hide = message.loading('提交中')
            sortRecommend(params).then(res =>{
                hide()
                if(res){
                    message.success('提交成功', 1.5, () => {                     
                        this.loadData()
                    })
                }
            }).catch(err =>{
                hide()
            })
        }
    }
    //模态框
    createModal = () =>{
        const { selectData,goodsList,selectedRowKeys } = this.state
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
          };
        return(
            <div>
                {this.state.isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
                <Form className="model_from">
                    <div tyle={{ maxWidth: 800 }}>
                        <Row gutter={24}>
                            <Col span={8}>
                                <Form.Item>
                                    <Search placeholder="请输入商品名称" onSearch={this.onSearchModel} enterButton />
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                </Form>
                 <Table
                    columns={this.columns2()}
                    dataSource={goodsList}
                    bordered
                    rowKey="id"
                    rowSelection={rowSelection}
                    pagination={{
                        current: selectData.current,
                        total: selectData.total,
                        pageSize: selectData.pageSize,
                    }}
                    onChange={this.selectPageChange}
                />
                <div className="btnBox">
                    <Button  onClick={() => { this.setState({createModelVisible: false}) }} style={{ marginRight: '10px' }}>取消</Button>
                    <Button  onClick={() => this.addSubmit()} style={{ marginRight: '10px' }} type="primary">确定</Button>
                </div>
            </div>
        )
    }
    columns = () =>{
        return [
            {
                title: <span>编号</span>,
                align: 'center',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: <span>商品名称</span>,
                align: 'center',
                render:item => <div>{item.goods.goodsName}</div>
            },
            {
                title: <span>商品原价</span>,
                align: 'center',
                render:item => <div>{item.goods.goodsName}</div>
            },
            {
                title: <span>剩余数量</span>,
                align: 'center',
                render:item => <div>{item.goods.goodsName}</div>
            },
            {
                title: <span>秒杀价格</span>,
                align: 'center',
                width:200,
                render:item =>  <div>
                    <InputNumber defaultValue={item.sort} min={1} onChange={(v)=>{
                        console.log(v)
                        this.setState({
                            sort:v
                        })
                    }} />
                    <Button style={{ marginLeft: '10px' }} type="primary" onClick={() =>this.sorting(item.id)}>确定</Button>
                </div>
            },
            {
                title: <span>秒杀数量</span>,
                align: 'center',
                width:200,
                render:item =>  <div>
                    <InputNumber defaultValue={item.sort} min={1} onChange={(v)=>{
                        console.log(v)
                        this.setState({
                            sort:v
                        })
                    }} />
                    <Button style={{ marginLeft: '10px' }} type="primary" onClick={() =>this.sorting(item.id)}>确定</Button>
                </div>
            },
            {
                title: <span>排序</span>,
                align: 'center',
                width:200,
                render:item =>  <div>
                    <InputNumber defaultValue={item.sort} min={1} onChange={(v)=>{
                        console.log(v)
                        this.setState({
                            sort:v
                        })
                    }} />
                    <Button style={{ marginLeft: '10px' }} type="primary" onClick={() =>this.sorting(item.id)}>确定</Button>
                </div>
            },
            {
                title: <span>状态</span>,
                align: 'center',
                render:item =><div>{item.isRecommend?'推荐中':'未推荐'}</div>
            },
            {
                title: <span>操作</span>,
                align: 'center',
                width: 100,
                render: item => <div>
                  <Button  onClick={() => { this.delRecommend(item.id)}} style={{ marginRight: '10px' }} type="danger">删除</Button>
                </div>,
            },
        ]
    }
    columns2 = () =>{
        return [
            {
                title: <span>商品名称</span>,
                align: 'center',
                dataIndex: 'goodsName',
                key: 'id',
            },
            {
                title: <span>价格</span>,
                align: 'center',
                render:item =><div>{item.goodSpecifications[0].salePrice/100}</div>
            }
        ]
    }

    render(){
        const { isLoading,list,pageData,createModelVisible,selectParam } = this.state
        return(
            <div className="freshGoods-page" style={{ padding: 20, backgroundColor: 'white' }}>
                {this.state.isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
                <Form className="goodlist_from">
                    <div style={{ maxWidth: 900 }}>
                    <Row gutter={24}>
                        <Col span={8}>
                        <Form.Item label="商品名称" >
                            <Search placeholder="请输入商品名称" onSearch={this.onSearchName} enterButton />
                        </Form.Item>
                        </Col>
                        <Col span={8}>
                        <Form.Item>
                            <Button  type="primary" icon="plus" style={{ width: 160 }} onClick={()=>{
                                selectParam.goodsName = ''
                                this.setState({
                                    createModelVisible: true,
                                    selectParam
                                })
                                this.getGoods()
                            }}>选择商品</Button>
                        </Form.Item>
                        </Col>
                    </Row>
                    </div>
                </Form>
                {
                !isLoading && (
                    <Table
                    columns={this.columns()}
                    dataSource={list}
                    bordered
                    rowKey="id"
                    pagination={{
                        current: pageData.current,
                        total: pageData.total,
                        pageSize: pageData.pageSize,
                    }}
                    onChange={this.onPageChange}
                    />
                )
                }
                <Modal
                    title="选择商品"
                    visible={createModelVisible}
                    onCancel={() => {
                        this.setState({
                        createModelVisible: false,
                        })
                    }}
                    width={800}
                    footer={false}
                    destroyOnClose
                    >
                    {this.createModal()}
                 </Modal>
            </div>
        )
    }
}

export default AddFlash